var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v("Activation")]),
    _vm._v(" "),
    _c("h4", [
      _vm._v(
        "Your instagram account service is activating. Please wait for a while. It takes about 10-30seconds."
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-5" }, [
      _vm.activating
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column justify-content-center align-items-center",
            },
            [
              _c("strong", [_vm._v("ACTIVATING...")]),
              _vm._v(" "),
              _c("md-progress-spinner", {
                staticClass: "md-accent text-danger",
                attrs: { "md-diameter": 70, "md-mode": "indeterminate" },
              }),
            ],
            1
          )
        : _c(
            "div",
            [
              _c("a-result", {
                attrs: {
                  title: "Great, Your instagram account service is activated!",
                },
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function () {
                      return [_c("a-icon", { attrs: { type: "check-circle" } })]
                    },
                    proxy: true,
                  },
                  {
                    key: "extra",
                    fn: function () {
                      return undefined
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }